import React from "react";
import { Box, Grid } from "@mui/material";
import { Skeleton } from "@mui/lab";
import SetDatabaseItem from "src/scenes/integrations/notion-setup/set-database-item";

const PreviouslySetNotionDatabases = ({ info }) => {
    return (
        <Box mt={3} mb={0}>
            <Grid
                container
                spacing={3}
                direction="column"
                alignItems="flex-start"
                justifyContent="center"
            >
                {!info || !info.notionDatabases || !info.notionDatabases.length ? (
                    <Skeleton
                        variant="rounded"
                        sx={{ borderRadius: "14px" }}
                        width={520}
                        height={220}
                    />
                ) : (
                    <Grid container>
                        <SetDatabaseItem
                            databases={info && info.notionDatabases}
                            setupFields={info && info.setupFields}
                        />
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export default PreviouslySetNotionDatabases;
